import moment from 'moment';
import { useMutation } from 'react-query';

import { axios } from '@/lib/axios';
import { MutationConfig, queryClient } from '@/lib/react-query';
import { useNotificationStore } from '@/stores/notifications';
import { usePatientStore } from '@/stores/patients';

import { Patient } from '../types';

export type UpdatePatientResponse = {
  success?: string;
  error?: string;
  clinic_users?: Patient[];
};

export type UpdatePatientDTO = {
  data: any;
};

export const updatePatient = ({ data }: UpdatePatientDTO): Promise<UpdatePatientResponse> => {
  return axios.post('/vue_api/update_patient', {
    ...data,
    dob: moment(data.dob, 'YYYY-MM-DD').unix(),
  });
};

type UseUpdatePatientOptions = {
  config?: MutationConfig<typeof updatePatient>;
};

export const useUpdatePatient = ({ config }: UseUpdatePatientOptions = {}) => {
  const { addNotification } = useNotificationStore();
  const { setPatients } = usePatientStore();

  return useMutation({
    // onMutate: async (newPatient) => {
    //   return;
    // },
    onError: (_, __, context: any) => {
      addNotification({
        type: 'error',
        title: 'There was a problem trying to update the Participant information',
      });
    },
    onSuccess: (data, vars) => {
      // queryClient.invalidateQueries(['patients', vars.clinic_user_id]);
      if (data.success && data.clinic_users) {
        setPatients(data.clinic_users);
      }
      addNotification({
        type: 'success',
        title: 'The Participant information has been updated',
      });
    },
    ...config,
    mutationFn: updatePatient,
  });
};
